import { API_URL } from "../../../config";
import { axios } from "../../../lib/axios";


export const getbundles = async (params:any, partnershipId: string) => {
    return axios.get(`https://api-cb.commbitz.com/globalytics/esim-plan`, {params,
        headers: {
          Partnerwebsiteid: partnershipId
        }});
}

export const couponVerify = async (params:any) => {
    return axios.post(`${API_URL}/vfsPhillip/scratch-coupon-verify`, params);
}

export const getCountries = async (params:any, partnershipId: string) => {
    return axios.get(`https://api-cb.commbitz.com/regions/countries?onlyCountries=true`, {params,
        headers: {
        //   Partnerwebsiteid: partnershipId
        }});
}


export const orderCreate = async (params:any) => {
    return axios.post(`https://api-cb.commbitz.com/order`, params);
}

export const createCart = async (params:any) => {
    return axios.post(`https://api-cb.commbitz.com/globalytics/carts`, params);
}
